module.exports = __webpack_public_path__ + "img/7.58ed0e5d.png";